import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown } from "../../shared/v1";
import Button from "@shared/v2/Button";
import IconButton from "@shared/v2/IconButton";
import { XmarkSolidV6 } from "@shared/v2/Icomoon";
import * as actions from "../actions/personDetailActionCreators";

const AddTag = ({ addTagToPerson, person }) => {
  const dispatch = useDispatch();
  const [addingTag, setAddingTag] = useState(false);
  const [selectedTag, setSelectedTag] = useState(null);
  const [newTagText, setNewTagText] = useState(null);
  const tagOptions = useSelector((state) => state.personDetail.tagOptions);

  const loadData = () => {
    if (addingTag && tagOptions.length === 0) {
      dispatch(actions.getTagsList());
    }
  };

  const onAddNewTag = (option) => {
    setSelectedTag(option.value);
    setNewTagText(option.label);
  };

  const onElementSave = () => {
    addTagToPerson(newTagText, person);
    setAddingTag(false);
    setNewTagText(null);
    setSelectedTag(null);
  };

  useEffect(() => {
    loadData();
  }, [addingTag]);

  return (
    <div>
      {addingTag && (
        <div className="tw-flex tw-justify-between tw-items-center tw-gap-[8px]">
          <Dropdown.Creatable
            className="tw-text-14d"
            onChange={onAddNewTag}
            isLoading={tagOptions.length === 0}
            isSearchable
            isClearable={false}
            options={tagOptions}
            placeholder="Search tags..."
            value={selectedTag}
          />
          <div className="tw-flex tw-gap-[4px]">
            <Button onClick={onElementSave}>Save</Button>
            <IconButton schema="tertiary" size="small" onClick={() => setAddingTag(false)}>
              <XmarkSolidV6 />
            </IconButton>
          </div>
        </div>
      )}
      {!addingTag && <Button onClick={() => setAddingTag(true)}>+ ADD</Button>}
    </div>
  );
};

export default AddTag;
